/**
 * @prettier
 */
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import NavLink from '../../../components/util/lgy-nav-link/LgyNavLink'
import EnterpriseSettingsNav from '../enterprise-settings/components/EnterpriseSettingsNav'
import LgyLoadingIcon from 'app/components/util/lgy-loading-icon/LgyLoadingIcon'
import { fetchAllPages } from '../settings/actions/settingsActions'

const AdminGearNav = ({ fetchAllPages, fetchingSettings }) => {
  useEffect(() => {
    fetchAllPages()
  }, [fetchAllPages])

  return fetchingSettings ? (
    <LgyLoadingIcon />
  ) : (
    <aside className='sidenav sticky'>
      <ul className='usa-sidenav-list'>
        <li>
          <NavLink activeClassName='usa-current' to='/lgyhub/admin/announcements'>
            Announcements
          </NavLink>
        </li>
        <li>
          <NavLink activeClassName='usa-current' to='/lgyhub/admin/jobs'>
            Jobs
          </NavLink>
        </li>
        <li>
          <NavLink activeClassName='usa-current' to='/lgyhub/admin/users'>
            Users
          </NavLink>
        </li>
        <li>
          <NavLink activeClassName='usa-current' to='/lgyhub/admin/help-tickets'>
            Help Tickets
          </NavLink>
        </li>
        <li>
          <NavLink activeClassName='usa-current' to='/lgyhub/admin/enterprise-settings'>
            Enterprise Settings
          </NavLink>
          <EnterpriseSettingsNav />
        </li>
      </ul>
    </aside>
  )
}

const mapStateToProps = ({
  adminState: {
    settings: { fetching }
  }
}) => ({ fetchingSettings: fetching })

export default connect(mapStateToProps, { fetchAllPages })(AdminGearNav)
